import { SUBSCRIBE_CHANNEL } from '../constants';
import createEntityLocalizer from '../utils/createEntityLocalizer';

// duplicate interface from number service until services are moved out of main framework package
interface NumberServiceOptions {
    showSymbol?: boolean;
    showPositiveSign?: boolean;
    precision?: number;
}

export interface LocalizedNumberProps {
    number: number;
    options?: NumberServiceOptions;
}

export const createLocalizedNumber = ({
    subscribeChannelKey = SUBSCRIBE_CHANNEL,
    handlerKey = 'localizeNumber',
} = {}) =>
    createEntityLocalizer<LocalizedNumberProps>({
        subscribeChannelKey,
        handlerKey,
        displayName: 'LocalizedNumber',
        entityName: 'number',
    });

const LocalizedNumber = createLocalizedNumber();

export default LocalizedNumber;
